import { useState, useCallback } from "react";
import { apiService } from "../services/apiClient";
import { apiUrl } from "../services/apiUrl";

export const useNavHeader = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch the personas/user-groups assigned to the caller
  const fetchUserGroupList = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get(apiUrl.aipdGetUserGroupListForUser());
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      console.error("Error fetching user group list:", errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch the caller's default persona/rl-type details
  const fetchUserDetails = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get(apiUrl.aipdGetUserDetails());
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      console.error("Error fetching user details:", errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Switch the caller's default persona/user-group
  const updateDefaultUserGroup = useCallback(async (email, userGroupId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.post(apiUrl.aipdUpdateDefaultUserGroup(), {
        email,
        userGroupId,
      });
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      console.error("Error updating default user group:", errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Update the caller's default RL-type
  const updateDefaultRlType = useCallback(async (rlType) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.post(apiUrl.aipdUpdateDefaultRlType(), {
        rlType,
      });
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      console.error("Error updating default RL type:", errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    loading,
    error,
    fetchUserGroupList,
    fetchUserDetails,
    updateDefaultUserGroup,
    updateDefaultRlType,
    clearError,
  };
};

export default useNavHeader;
